import { render } from "./CTASubsection.vue?vue&type=template&id=24add02d&ts=true"
import script from "./CTASubsection.vue?vue&type=script&lang=ts"
export * from "./CTASubsection.vue?vue&type=script&lang=ts"

import "./CTASubsection.vue?vue&type=style&index=0&id=24add02d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__